// extracted by mini-css-extract-plugin
var _1 = "250px";
export { _1 as "sidebarWidth" }
